import TabStripBase from "../../components/shared/tabstrip";
import Tab from "./Tab";
import React from "react";

const TabStrip: React.FC<Parameters<typeof TabStripBase>[0]> = ({
  children,
  ...props
}) => {

  return <TabStripBase {...props}>{children}</TabStripBase>;
};

export { Tab };
export default TabStrip;
